<template>
  <div id="SectionNetZeroPricing">
    <UIContainer class="SectionNetZeroPricing__container">
      <div class="SectionNetZeroPricing__content">
        <SectionTitle>
          <template #heading>Investment based on Company size</template>
          <template #title>Pricing plans that scale</template>
          <template #description>
            Have a buyer deadline or reassessment date approaching? Book a
            20-minute scoping call—leave with a timeline, an input checklist,
            and a fixed-price proposal.
          </template>
        </SectionTitle>

        <UIButton s1ize="xl" theme="primary" :to="{ name: 'Contact' }">
          Book a call
        </UIButton>
      </div>

      <div class="SectionNetZeroPricing__plans">
        <PricingPlan v-for="plan in plans" :key="plan.title" v-bind="plan" />
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import PricingPlan, { IPlan } from '@/views/components/misc/PricingPlan.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'

const plans: IPlan[] = [
  {
    title: 'GHG Report Compliance',
    // price: '€8,000',
    features: [
      'Scope 1 & 2 Physical, Scope 3 Financial',
      'Employee engagement',
      'Grouped Kick-Off',
      'Dedicated expert',
    ],
    ctaText: 'Start assessment',
    ctaTheme: 'primary',
    ctaStyle: 'filled',
  },
  {
    title: 'Net Zero Contributor',
    // price: 'From €4,590',
    features: [
      'Scope 1 & 2 Physical',
      'Full Scope 3 Physical analysis',
      'Reduction actions',
      'Employee engagement',
      'Supplier engagement',
      'Grouped Kick-Off',
      'Dedicated expert & workshop',
      'Report presentation',
    ],
    ctaText: 'Get a quote',
    ctaTheme: 'primary',
    ctaStyle: 'filled',
  },
]
</script>

<style lang="scss" scoped>
#SectionNetZeroPricing {
  .SectionNetZeroPricing__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;

    @include md {
      gap: 4rem;
      grid-template-columns: 440px 1fr;
    }
  }

  .SectionNetZeroPricing__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include md {
      gap: 1.25rem;
    }
  }

  .SectionNetZeroPricing__plans {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include md {
      gap: 2rem;
      flex-direction: row;
    }
  }
}
</style>
